import React from 'react';
import { format, parse } from 'date-fns';
import { IconButton, Pane, TickIcon, TrashIcon } from 'evergreen-ui';

import { TextInputBlur } from 'Shared/TextInputBlur';
import { DATE_FORMATS } from 'Utils/formats';
import { HEIGHT } from './utils';

/**
 * @param {object} props
 * @prop {string | undefined} value дата в формате formatValue ??
 * @prop {({value, name, valueId?}) => void} updateValue функция для обновление значения value
 * @prop {string} [formatValue] формат вводимой даты, по умолчанию формат для input datetime
 * @prop ...textInputFieldProps
 */
export const MeasureDate = React.memo(({
  paramId,
  codeId,
  valueType,
  formatValue,
  updateValue,
  ...inputProps
}) => {
  // чтобы проще было отличать атрибуты от "собственных"
  const {
    label = '',
    value, // будет в формате thisFormatValue
    onChange,
  } = inputProps;

  const thisFormatValue = React.useMemo(() => (
    formatValue ? formatValue?.replace('hh', 'HH') : DATE_FORMATS.inputDatetime
  ), [formatValue]);

  const maxDate = React.useMemo(() => format(new Date(), DATE_FORMATS.inputDatetime), []);
  const inputValue = React.useMemo(() => (
    value ? format(parse(value, thisFormatValue, new Date()), DATE_FORMATS.inputDatetime) : ''
  ), [thisFormatValue, value]);

  const thisUpdateValue = React.useCallback((e) => {
    updateValue && updateValue({ value: e.target.value, name: e.target.name });
    onChange && onChange(e);
  }, [onChange, updateValue]);
  const clearDate = React.useCallback(() => {
    updateValue && updateValue({ value: '', name: inputProps.name });
  }, [inputProps.name, updateValue]);

  return (
    <Pane display="flex" columnGap=".25rem">
      <TextInputBlur
        type="datetime-local"
        className="program-measure-input"
        label={label}
        value={inputValue}
        autoComplete="off"
        width="auto"
        inputHeight={HEIGHT}
        margin={0}
        max={maxDate}
        {...inputProps}
        updateValue={thisUpdateValue}
      />
      {
        !inputProps.disabled && (
          <>
            <IconButton
              height={HEIGHT}
              icon={TickIcon}
              intent="success"
              alignSelf="end"
            />
            <IconButton
              disabled={!inputValue}
              height={HEIGHT}
              icon={TrashIcon}
              intent="danger"
              alignSelf="end"
              onClick={clearDate}
            />
          </>
        )
      }
    </Pane>
  );
});
MeasureDate.displayName = 'MeasureDate';
